"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Ellipsis = _interopRequireDefault(require("../Ellipsis"));
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var TicketInfo = function TicketInfo(props) {
  var className = props.className,
    style = props.style,
    responsive = props.responsive,
    title = props.title,
    time = props.time,
    img = props.img,
    list = props.list,
    organizer = props.organizer,
    btns = props.btns;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("ticket-info");
  var classes = (0, _classnames.default)(prefixCls, {
    responsive: !!responsive
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__hd")
  }, /*#__PURE__*/_react.default.createElement(_Ellipsis.default, {
    line: 2,
    className: "".concat(prefixCls, "__tit")
  }, title), organizer && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__org")
  }, organizer), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__time")
  }, time)), /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(prefixCls, "__img"),
    src: img,
    alt: ""
  }), !!list && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__list-wrap")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__list-tit")
  }, "\u60A8\u9009\u62E9\u7684\u95E8\u7968"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(prefixCls, "__list")
  }, list.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "".concat(prefixCls, "__item"),
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__item-main")
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(prefixCls, "__item-tit")
    }, item.title), /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(prefixCls, "__item-num")
    }, item.num)), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__item-price")
    }, item.price));
  }))), btns && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__btns")
  }, btns));
};
TicketInfo.defaultProps = {};
var _default = TicketInfo;
exports.default = _default;